import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireGroupeEmail.module.scss';
import { AiOutlineClose } from 'react-icons/ai';
import { RiMailSendFill } from 'react-icons/all';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import { glossaire_alarm_level } from '../../../../../ressources/glossaires/glossaire_niveau_alarme';
import Bouton from '../../../Bouton/Bouton';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import FormulaireSelectionProjet from '../../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import * as actions from '../../../../../services/actions';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../MessageErreur/MessageErreur';
import {
  schemaNouveauGroupeEmail,
  schemaModificationGroupeEmail,
} from '../../../../../services/schemas/groupeEmail';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../../services/schemas/validerFormulaire';

const FormulaireGroupeEmail = ({
  preconfigurerGroupeEmail,
  affichageProfil,
}) => {
  const dispatch = useDispatch();

  // Separate state declarations
  const [projectId, setProjectId] = useState(null);
  const [emailGroupName, setEmailGroupName] = useState('');
  const [listEmails, setListEmails] = useState([]);
  const [groupEmailId, setGroupEmailId] = useState(null);
  const [erreurs, setErreurs] = useState({});
  const erreurDuChamp = (champ) => messageDuChamp(erreurs, champ);

  // Update useEffect to handle separate states
  useEffect(() => {
    if (preconfigurerGroupeEmail) {
      setProjectId(preconfigurerGroupeEmail.project_id);
      setEmailGroupName(preconfigurerGroupeEmail.email_group_name);
      setListEmails(preconfigurerGroupeEmail.list_emails);
      setGroupEmailId(preconfigurerGroupeEmail.group_email_id);
    }
  }, [preconfigurerGroupeEmail]);

  // Update handlers for individual state updates
  const gererEtatEmailGroupName = (event) => {
    setEmailGroupName(event.target.value);
  };

  // Update handlers with modern React patterns
  const gererEtatEmail = (event, indEmail) => {
    const newEmails = [...listEmails];
    newEmails[indEmail] = {
      ...newEmails[indEmail],
      email: event.target.value,
    };
    setListEmails(newEmails);
  };

  const gererSupprimerEmail = (indEmail) => {
    const newEmails = [...listEmails];
    newEmails.splice(indEmail, 1);
    setListEmails(newEmails);
  };

  const gererEtatCheckboxSeuil = (indEmail, checkboxValue, cleSeuil) => {
    const newEmails = [...listEmails];
    const { list_alarms_levels_favorites } = newEmails[indEmail];

    newEmails[indEmail] = {
      ...newEmails[indEmail],
      list_alarms_levels_favorites: checkboxValue
        ? list_alarms_levels_favorites.filter((v) => v !== cleSeuil)
        : [...list_alarms_levels_favorites, cleSeuil],
    };

    setListEmails(newEmails);
  };

  const gererProjetId = (projetId) => {
    setProjectId(projetId);
  };

  const reqEnvoi = () => {
    // Le projet part tel que choisi : le schéma le convertit. Aucune règle ne
    // s'appliquait jusqu'ici : un groupe sans nom, sans projet (parseInt
    // donnait NaN, envoyé en null) ou avec une adresse mal formée partait tel
    // quel.
    const enCreation = !groupEmailId;
    const formulaireGroupeEmail = {
      project_id: projectId,
      email_group_name: emailGroupName,
      list_emails: listEmails,
    };
    if (!enCreation) {
      formulaireGroupeEmail.group_email_id = groupEmailId;
    }

    const resultat = validerFormulaire(
      enCreation ? schemaNouveauGroupeEmail : schemaModificationGroupeEmail,
      formulaireGroupeEmail
    );
    setErreurs(resultat.erreurs);
    if (!resultat.valide) {
      return;
    }

    if (enCreation) {
      dispatch(actions.reqCreerGroupeEmail(resultat.donnees));
    } else {
      dispatch(actions.reqModifierGroupeEmail(resultat.donnees));
    }
  };

  const renderBoutons = () => {
    if (affichageProfil) return null;

    const reqType = preconfigurerGroupeEmail
      ? requestType.modifier_un_groupe_d_email
      : requestType.creer_un_groupe_d_email;

    const buttonText = preconfigurerGroupeEmail
      ? checkMot('envoi_modification')
      : checkMot('envoi_creation');

    return (
      <AttenteRequete
        request_type={reqType}
        str={checkMot('modification_en_cours')}
      >
        <button className={styles.btF} onClick={reqEnvoi}>
          <RiMailSendFill size={24} /> {buttonText}
        </button>
      </AttenteRequete>
    );
  };

  return (
    <div className={styles.ConteneurInfo}>
      <div
        className={[s.container, s.border, s.text_left, styles.Formulaire].join(
          ' '
        )}
      >
        <FormulaireSelectionProjet
          affichageProfil={affichageProfil}
          gererProjetId={gererProjetId}
          preconfigurerProjetId={projectId}
        />
        <MessageErreur cle={erreurDuChamp('project_id')} />

        {/* Update email group name input */}
        <div className={s.form_group}>
          <label className={styles.label} htmlFor="inlineFormCustomSelect">
            {checkMot('groupe_email_name')}
          </label>
          <div className={[s.form_row, s.align_items_center].join(' ')}>
            <div className={s.col_12}>
              <input
                type="text"
                pattern="[0-9a-zA-Z._%+-\\s ]+"
                className={[
                  s.form_control,
                  s.mb_2,
                  erreurDuChamp('email_group_name') ? classeChampEnErreur : '',
                ].join(' ')}
                name="email_group_name"
                placeholder="email_group_name"
                value={emailGroupName}
                disabled={affichageProfil}
                onChange={gererEtatEmailGroupName}
              />
              <MessageErreur cle={erreurDuChamp('email_group_name')} />
            </div>
          </div>
        </div>

        {/* Update email list section */}
        <div className={[s.form_row, s.align_items_center].join(' ')}>
          <div className={s.col_sm_12}>
            {!affichageProfil && (
              <Bouton
                cliquer={() =>
                  setListEmails((prev) => [
                    ...prev,
                    { email: '', list_alarms_levels_favorites: [] },
                  ])
                }
              >
                {checkMot('ajouter_un_email')}
              </Bouton>
            )}
          </div>

          <div className={s.row}>
            {listEmails.map((objEmail, indEmail) => (
              <div key={indEmail} className={styles.col}>
                <input
                  type="text"
                  className={
                    erreurDuChamp(`email_${indEmail}`)
                      ? classeChampEnErreur
                      : ''
                  }
                  name={`email_${indEmail}`}
                  placeholder="email"
                  value={objEmail.email}
                  disabled={affichageProfil}
                  onChange={(event) => gererEtatEmail(event, indEmail)}
                />
                <MessageErreur cle={erreurDuChamp(`email_${indEmail}`)} />
                {!affichageProfil && (
                  <div className={styles.btnn}>
                    <Bouton cliquer={() => gererSupprimerEmail(indEmail)}>
                      <AiOutlineClose />
                    </Bouton>
                  </div>
                )}
                {Object.keys(glossaire_alarm_level).map((cleAlarme) => {
                  const checkboxValue =
                    listEmails[indEmail].list_alarms_levels_favorites.indexOf(
                      parseInt(cleAlarme)
                    ) > -1;
                  return (
                    <div
                      key={cleAlarme}
                      className={styles.margin}
                      onChange={() =>
                        gererEtatCheckboxSeuil(
                          indEmail,
                          checkboxValue,
                          parseInt(cleAlarme)
                        )
                      }
                    >
                      <input
                        className={styles.margin}
                        disabled={affichageProfil}
                        type="checkbox"
                        checked={checkboxValue}
                      />
                      {glossaire_alarm_level[cleAlarme]}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {renderBoutons()}
      </div>
    </div>
  );
};

export default FormulaireGroupeEmail;
